import styled, { css } from 'styled-components';
import { FlexLayout } from '@gv/triage-components';

export const Pet = styled(FlexLayout)<{ $selected: boolean }>`
  gap: 16px;
  padding: 24px;
  cursor: pointer;
  align-items: center;

  ${({ theme, $selected }) => css`
    border-radius: ${theme.borderRadius};
    box-shadow: inset 0 0 0 ${$selected ? 2 : 1}px
      ${$selected ? theme.config.text.primary : theme.config.numberCard.border};

    background-color: ${$selected
      ? theme.config.table.grey.action.bg
      : 'transparent'};

    &:hover {
      background-color: ${$selected
        ? theme.config.table.grey.hover.bg
        : theme.config.table.grey.hover.bg};
    }

    &:active {
      background-color: ${$selected
        ? theme.config.table.grey.action.bg
        : theme.config.table.grey.action.bg};
    }

    svg {
      width: 40px;
      height: 40px;
      path {
        fill: ${$selected
          ? theme.config.text.primary
          : theme.config.text.primary};
        opacity: ${$selected ? 1 : 0.8};
      }
    }
  `}
`;
